module.exports = __webpack_public_path__ + "static/media/icon_select5.cd16a0c7.svg";